import React from 'react';
import { Box, SimpleGrid } from '@chakra-ui/react';
import ProductCard from '@components/molecules/ProductCard';
import FutureCard from '@components/molecules/FutureCard';

const ProductGrid = ({ futureProductText, products = [] }) => {
  return (
    <SimpleGrid
      columns={{ base: 2, xl: 3 }}
      py={{ base: `1.5rem`, md: `3rem` }}
      spacing={{ base: `0.938rem`, lg: `2rem` }}
      rounded="lg"
      color="gray.400">
      {products.map((product, i) => {
        return (
          <Box key={`products${i + 1}`} pb={{ base: `2.063rem`, md: `0` }}>
            <ProductCard
              productData={product}
              isClickable
              isOdd={i % 2 === 0}
              orderIndex={i + 1}
            />
          </Box>
        );
      })}
    </SimpleGrid>
  );
};

export default ProductGrid;
